import React from 'react';
import { Row } from 'reactstrap';

import './ErrorFeedback.scss';

type ErrorFeedbackProps = {
  serverErrors?: any;
  formError?: string;
  errorContainerStyle?: string;
  errorMessageStyle?: string;
};

const ErrorFeedback = ({
  serverErrors = [],
  formError = '',
  errorContainerStyle = '',
  errorMessageStyle = '',
}: ErrorFeedbackProps) => {
  // server error should be shown if there's any
  if (serverErrors.length || formError) {
    const errorData = serverErrors.length ? serverErrors[0] : formError;
    return (
      <Row className="error-feedback-container">
        <div
          className={`error-feedback-message-container my-1 ${errorContainerStyle}`}
        >
          <div className={`error-message ${errorMessageStyle}`}>{errorData}</div>
        </div>
      </Row>
    );
  }

  return null;
};

export default ErrorFeedback;
